import request, { FAIL, SUCCESS } from "../util/Request";

interface FormData {
  vocNumber: string;
  phoneNumber: string;
  password: string;
}

interface WriteData {
  title: string;
  content: string;
  name: string;
  password: string;
  phoneNumber: string;
  serviceSortation: string;
  email: string;
}

interface IVocCreateResponse {
  status: string;
  data?: any;
}

const UserBoardService = {
  writeVoc: async (writeData: WriteData, uploadFile: Blob): Promise<IVocCreateResponse> => {
    const formData = new FormData();
    const keys = Object.keys(writeData);
    for (const k of keys) {
      formData.append(k, writeData[k as keyof WriteData]);
    }
    formData.append("data", uploadFile);
    try {
      const headers: any = { "Content-Type": "multipart/form-data" };
      const response = await request.post(`/vocCreate`, formData, {
        headers,
      });
      if (request.isSuccess(response)) {
        return {
          ...response,
          status: SUCCESS,
        };
      }
      return { status: FAIL };
    } catch (error) {
      return {
        status: FAIL,
      };
    }
  },
  searchVoc: async (formData: FormData) => {
    const no = formData.vocNumber;
    const phoneNumber = formData.phoneNumber;
    const password = formData.password;
    try {
      const response = await request.get(`/vocSearch?no=${no}&phoneNumber=${phoneNumber}&password=${password}`);

      if (request.isSuccess(response)) {
        return {
          ...response,
          status: SUCCESS,
        };
      }
      return { status: FAIL };
    } catch (error) {
      return {
        status: FAIL,
      };
    }
  },
};
export default UserBoardService;
